export const REACT_APP_HOST_URL = process.env.REACT_APP_HOST_URL;
export const REACT_APP_API_URL = process.env.REACT_APP_API_URL;
export const REACT_APP_ENV = process.env.REACT_APP_ENV;
